// FIXME: Page names are missing, need to be added later
import { fr_CH_NavRoutes } from './fr-CH';

export const hr_HR_NavRoutes = {
    ...fr_CH_NavRoutes,
};
